module.exports = __webpack_public_path__ + "img/img_inner_redtartan.da56fdb2.png";